import React from 'react';
import {connect} from 'react-redux';

import * as actions from '../../../store/actions'


class PacefiFullScreenSpinner extends React.PureComponent {

    render () {
        if (!this.props.loaderOn) return <></>

        return (
            <div className="full-screen-loader" data-testid="full-screen-loader">
                <div className="pacefi-hex-spinner"/>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    loaderOn: state.session.globalLoaderOn
})



export default connect(mapStateToProps)(PacefiFullScreenSpinner)
